<template>
  <div id="box">
    <div class="inner">
      <h1 v-html="'xID APP'" />
      <div class="wrapper">
        <CustomButton
          :isSingle="true"
          :buttonType="'primary'"
          :customButtonTxt="'Launch xID app'"
          @submit="directAPP"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
export default {
  name: "Bypass",
  components: {
    CustomButton,
  },
  methods: {
    directAPP() {
      window.location.href =
        process.env.VUE_APP_SCHEMEPATH +
        "xid.me/bypass?token=" +
        this.$route.query.token;
    },
  },
};
</script>

<style lang="sass" scoped>
.expandWrapper
  +flex()
  .img
    +size(80%)
</style>